import React, {Component} from "react";
import { observer } from "mobx-react";
import {checkByte, onlyNumber} from "../../../../utils/Utils";
import {fn_deliverySelfInput} from "../../../../function/FnBodySetting";
import {fn_deliverySelfClose} from "../../../../function/FnBodyLayer";

@observer
class DefaultSelfDeliveryLayer extends Component {

    validateName = nameFild => {
        const { rootStore } = this.props;
        rootStore.deliveryStore.setDeliveryAspForm("empNm",nameFild.value.trim())
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        if (checkByte(aspFormData.empNm, 12)) {
            rootStore.deliveryStore.setDeliveryAspForm("isNameValid",true)
        }else{
            rootStore.deliveryStore.setDeliveryAspForm("isNameValid",false)
        }
        this.validateNameErrorMessage()
    }

    validateNameErrorMessage = () => {
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        switch (aspFormData.isNameValid) {
            case false:
                return "한글 최대 6자, 영문 최대 12자까지 입력 가능합니다"
            default:
                return ""
        }
    };

    validatePosPass = passwordFild => {
        const { rootStore } = this.props;
        rootStore.deliveryStore.setDeliveryAspForm("empPw",onlyNumber(passwordFild.value))
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        if (!checkByte(aspFormData.empPw, 10)) {
            rootStore.deliveryStore.setDeliveryAspForm("isPosPassValid",false)
        }else{
            rootStore.deliveryStore.setDeliveryAspForm("isPosPassValid",true)
        }
        this.validatePosPassErrorMessage();
    }

    validatePosPassErrorMessage = () => {
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        switch (aspFormData.isPosPassValid) {
            case false:
                return "숫자 최대 10자까지 입력 가능"
            default:
                return ""
        }
    }

    validatePosRePass = passwordReFild => {
        const { rootStore } = this.props;
        rootStore.deliveryStore.setDeliveryAspForm("reEmpPw",onlyNumber(passwordReFild.value))
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        if( aspFormData.empPw != aspFormData.reEmpPw ){
            rootStore.deliveryStore.setDeliveryAspForm("isPosRePassValid",false)
        }else{
            rootStore.deliveryStore.setDeliveryAspForm("isPosRePassValid",true)
        }
        this.validatePosRePassErrorMessage();
    }

    validatePosRePassErrorMessage = () => {
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        switch (aspFormData.isPosRePassValid) {
            case false:
                return "포스비밀번호가 일치하지 않습니다."
            default:
                return ""
        }
    }

    setWorkType = workSelect =>{
        const { rootStore } = this.props;
        rootStore.deliveryStore.setDeliveryAspForm("retireFlag",workSelect)
    }

    isEveryFieldValid = () => {
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        return aspFormData.isNameValid && aspFormData.isPosPassValid && aspFormData.isPosRePassValid;
    }

    renderSubmitBtn = () => {
        if (this.isEveryFieldValid()) {
            return (
                <button type="submit" >배달원 등록</button>
            )
        }
        return (
            <button type="submit" disabled>배달원 등록</button>
        )
    }

    isEveryFieldValidEdit = () => {
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        return (aspFormData.isNameValid===null)?false:aspFormData.isNameValid;
    }

    renderEditSubmitBtn = () => {
        if (this.isEveryFieldValidEdit()) {
            return (
                <button type="submit" >수정</button>
            )
        }
        return (
            <button type="submit" disabled>수정</button>
        )
    }

    handleSubmit = (event) => {
        const { rootStore } = this.props;
        event.preventDefault();
        fn_deliverySelfInput(rootStore);
    }

    createForm = () =>{
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        return(
            <>
                <div className="section_tit_comm">
                    <h1>자체배달원 등록</h1>
                </div>
                <form name="manInfo" onSubmit={this.handleSubmit}>
                    <div className="section_delivery_info">
                        <h2>자체배달원 정보를 입력해주세요</h2>
                        <dl className="wrap_delivery_info">
                            <dt>사원명</dt>
                            <dd><input type="text" placeholder="한글 최대 6자, 영문 최대 12자까지 입력 가능" required
                                       value={aspFormData.empNm} onChange={e => this.validateName(e.target)}/></dd>
                        </dl>
                        <p className="txt_alert">{this.validateNameErrorMessage()}</p>
                        <dl className="wrap_delivery_info">
                            <dt>포스비밀번호</dt>
                            <dd><input type="password" placeholder="숫자 최대 10자까지 입력 가능" required
                                       value={aspFormData.empPw} onChange={e => this.validatePosPass(e.target)}/></dd>
                        </dl>
                        <p className="txt_alert">{this.validatePosPassErrorMessage()}</p>
                        <dl className="wrap_delivery_info">
                            <dt>포스비밀번호 확인</dt>
                            <dd><input type="password" placeholder="숫자 최대 10자까지 입력 가능 " required
                                       value={aspFormData.reEmpPw} onChange={e => this.validatePosRePass(e.target)}/></dd>
                        </dl>
                        <p className="txt_alert">{this.validatePosRePassErrorMessage()}</p>
                        <dl className="wrap_delivery_info">
                            <dt>퇴직구분<span>재직중인 사원만 배달 요청할 수 있습니다.</span></dt>
                            <dd>
                                <label><input type="radio" name="classification"
                                              checked={(aspFormData.retireFlag === '0') ? true : false}
                                              onChange={() => this.setWorkType("0")}/><span>재직</span></label>
                                <label><input type="radio" name="classification"
                                              checked={(aspFormData.retireFlag === '2') ? true : false}
                                              onChange={() => this.setWorkType("2")}/><span>휴직</span></label>
                                <label><input type="radio" name="classification"
                                              checked={(aspFormData.retireFlag === '1') ? true : false}
                                              onChange={() => this.setWorkType("1")}/><span>퇴직</span></label>
                            </dd>
                        </dl>
                        <div className="wrap_full_btn">
                            {this.renderSubmitBtn()}
                        </div>
                    </div>
                </form>
            </>
        )
    }

    editForm = () =>{
        const { rootStore } = this.props;
        const aspFormData = rootStore.deliveryStore.getDeliveryAspForm;
        return(
            <>
                <div className="section_tit_comm">
                    <h1>자체배달원 정보 수정</h1>
                </div>
                <form name="manInfo" onSubmit={this.handleSubmit}>
                <div className="section_delivery_info">
                    <h2>자체배달원 정보를 입력해주세요</h2>
                    <dl className="wrap_delivery_info">
                        <dt>사원번호</dt>
                        <dd><input type="text" placeholder="숫자 최대 10자까지 입력 가능" value={aspFormData.empNo} disabled /></dd>
                    </dl>
                    <dl className="wrap_delivery_info">
                        <dt>사원명</dt>
                        <dd><input type="text" placeholder="한글 최대 6자, 영문 최대 12자까지 입력 가능" required
                                   value={aspFormData.empNm} onChange={e => this.validateName(e.target)}/></dd>
                    </dl>
                    <p className="txt_alert">{this.validateNameErrorMessage()}</p>
                    <dl className="wrap_delivery_info">
                        <dt>퇴직구분<span>재직중인 사원만 배달 요청할 수 있습니다.</span></dt>
                        <dd>
                            <label><input type="radio" name="classification"
                                          checked={(aspFormData.retireFlag === '0') ? true : false}
                                          onChange={() => this.setWorkType("0")}/><span>재직</span></label>
                            <label><input type="radio" name="classification"
                                          checked={(aspFormData.retireFlag === '2') ? true : false}
                                          onChange={() => this.setWorkType("2")}/><span>휴직</span></label>
                            <label><input type="radio" name="classification"
                                          checked={(aspFormData.retireFlag === '1') ? true : false}
                                          onChange={() => this.setWorkType("1")}/><span>퇴직</span></label>
                        </dd>
                    </dl>
                    <div className="wrap_full_btn">
                        {this.renderEditSubmitBtn()}
                    </div>
                </div>
                </form>
            </>
        )
    }

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerDeliverySelfView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        {
                            (rootStore.deliveryStore.getDeliveryAspForm.actionFlag === 'C')?this.createForm():this.editForm()
                        }
                        <div className="btn_close btn_close_comm">
                            <button onClick={event => fn_deliverySelfClose(rootStore)}><span>닫기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DefaultSelfDeliveryLayer;